import React, { createContext, useCallback, useContext, useEffect, useState } from "react";

const STORAGE_KEY = "app-theme";

const getInitialTheme = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "dark" || stored === "light") return stored;
  } catch (e) {
    // localStorage unavailable — fall back to light
  }
  return "light";
};

const ThemeContext = createContext(null);

/**
 * Drives the `data-theme` attribute on <html> that assets/glass/_tokens.scss
 * reads to swap its CSS custom properties between light/dark values, and
 * exposes the current mode + a toggle to any component via useTheme().
 * Persisted to localStorage so the choice survives reloads.
 */
export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(getInitialTheme);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch (e) {
      // ignore
    }
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
